import { isEmpty, uniq } from 'lodash'
import i18n from 'translations/i18n'
import ATSJobOpenStatuses from './components/ATSJobOpenStatuses'
import AssetTypes from './components/AssetTypes'
import AssetsStatus from './components/AssetsStatus'
import BusinessUnits from './components/BusinessUnits'
import CandidateStatuses from './components/CandidateStatuses'
import Country from './components/Country'
import Departments from './components/Departments'
import DocumentTypes from './components/DocumentTypes'
import EmploymentType from './components/EmploymentType'
import GosiLinked from './components/GosiLinked'
import Grades from './components/Grades'
import JobOpeningType from './components/JobOpeningType'
import JobTitles from './components/JobTitles'
import LoanTypes from './components/LoanTypes'
import Locations from './components/Locations'
import MolRegistrations from './components/MolRegistrations'
import Nationalities from './components/Nationalities'
import Nationality from './components/Nationality'
import OutOfPayrollTypes from './components/OutOfPayrollTypes'
import OutsourcingCompanies from './components/OutsourcingCompanies'
import PaymentDetails from './components/PaymentDetails'
import PaymentMethods from './components/PaymentMethods'
import PayrollTransactionStatus from './components/PayrollTransactionStatus'
import PayrunStatus from './components/PayrunStatus'
import PayrunTypes from './components/PayrunTypes'
import PunchIn from './components/PunchIn'
import PunchOut from './components/PunchOut'
import ReportingMethods from './components/ReportingMethods'
import RequestStatuses from './components/RequestStatuses'
import RequestTypes from './components/RequestTypes'
import RequestsPendingOn from './components/RequestsPendingOn'
import ShiftType from './components/ShiftType'
import Shifts from './components/Shifts'
import StatusEmployee from './components/StatusEmployee'
import FinalVacationStatus from './components/FinalVacationStatus'
import AttendanceStatus from './components/AttendanceStatus'
import CommercialRegistrations from './components/CommercialRegistrations'
import PaymentProcessingMethods from './components/PaymentProcessingMethods'
import GosiLinkedPaymentProcessing from './components/GosiLinkedPaymentProcessing'
import ExternalNationalities from './components/ExternalNationalities'
import IdTypes from './components/IdTypes'
import InsuranceClasses from './components/InsuranceClasses'
import InsuranceStatus from './components/InsuranceStatus'
import MemberLinked from './components/MemberLinked'
import Areas from './components/Areas'
import DeviceStatus from './components/DeviceStatus'
import EndorsementRequestType from './components/EndorsementRequestType'
import EndorsementMemberType from './components/EndorsementMemberType'
import EmpAuditLogActions from './components/EmpAuditLogActions'
import Duration from './components/Duration'
import EmployeeInvitationsStatus from './components/EmployeeInvitationsStatus'

export const filterComponent = [
  {
    title: 'area',
    component: Areas,
    filterKey: 'area_ids',
    extra_title: 'location_area',
  },
  {
    title: 'departments',
    component: Departments,
    filterKey: 'department_ids',
  },
  {
    title: 'grades',
    component: Grades,
    filterKey: 'grade_ids',
  },
  {
    title: 'grades',
    extra_title: 'grade_id',
    component: Grades,
    filterKey: 'grade_id',
  },
  {
    title: 'job_titles',
    component: JobTitles,
    filterKey: 'job_title_ids',
  },
  {
    title: 'job_title',
    extra_title: 'job_title_id',
    component: JobTitles,
    filterKey: 'job_title_id',
  },
  {
    title: 'nationalities',
    component: Nationalities,
    filterKey: 'nationalities',
  },
  {
    title: 'nationality',
    component: Nationality,
    filterKey: 'nationality',
  },
  {
    title: 'country',
    component: Country,
    filterKey: 'country',
  },
  {
    title: 'outsourcing_company',
    component: OutsourcingCompanies,
    filterKey: 'outsourcing_company_ids',
  },
  {
    title: 'mol_registrations',
    component: MolRegistrations,
    filterKey: 'mol_registration_ids',
  },
  {
    title: 'gosi_subscriptions',
    component: MolRegistrations,
    filterKey: 'gosi_subscriptions',
  },
  {
    title: 'shifts',
    component: Shifts,
    filterKey: 'shift_ids',
  },
  {
    title: 'gosi_linked',
    component: GosiLinked,
    filterKey: 'is_gosi_linked',
  },
  {
    title: 'payment_details',
    extra_title: 'uncorrect_data',
    component: PaymentDetails,
    filterKey: 'is_data_correct',
  },
  {
    title: 'locations',
    component: Locations,
    filterKey: 'location_ids',
  },
  {
    title: 'location',
    extra_title: 'location_id',
    component: Locations,
    filterKey: 'location_id',
  },
  {
    title: 'record_location',
    component: Locations,
    filterKey: 'record_location_ids',
  },
  {
    title: 'statuses',
    extra_title: 'status_employee',
    component: StatusEmployee,
    filterKey: 'status_employee',
  },
  {
    title: 'shift_type',
    component: ShiftType,
    filterKey: 'shift_type',
  },
  {
    title: 'business_unit',
    extra_title: 'business_unit_id',
    component: BusinessUnits,
    filterKey: 'business_unit_id',
  },
  {
    title: 'business_units',
    component: BusinessUnits,
    filterKey: 'business_unit_ids',
  },
  {
    title: 'department_id',
    component: Departments,
    filterKey: 'department_id',
  },
  {
    title: 'employment_types',
    component: EmploymentType,
    filterKey: 'employment_type_ids',
  },
  {
    title: 'employment_type_id',
    component: EmploymentType,
    filterKey: 'employment_type_id',
  },
  {
    title: 'job_openings',
    component: JobOpeningType,
    filterKey: 'job_openings',
  },
  {
    title: 'punch_in',
    component: PunchIn,
    filterKey: 'punch_in',
  },
  {
    title: 'punch_out',
    component: PunchOut,
    filterKey: 'punch_out',
  },
  {
    title: 'reporting_method',
    component: ReportingMethods,
    filterKey: 'reporting_method_ids',
  },
  {
    title: 'document_types',
    component: DocumentTypes,
    filterKey: 'document_type',
  },
  {
    title: 'payment_methods',
    component: PaymentMethods,
    filterKey: 'payment_methods',
  },
  {
    title: 'loan_types',
    component: LoanTypes,
    filterKey: 'loan_type_ids',
  },
  {
    title: 'payrun_types',
    component: PayrunTypes,
    filterKey: 'payrun_types',
  },
  {
    title: 'payrun_status',
    component: PayrunStatus,
    filterKey: 'payrun_status',
  },
  {
    title: 'filter_payrun_status',
    component: FinalVacationStatus,
    filterKey: 'filter_payrun_status',
  },
  {
    title: 'filter_attendance_status',
    component: AttendanceStatus,
    filterKey: 'filter_attendance_status',
  },
  {
    title: 'payroll_transaction_status',
    component: PayrollTransactionStatus,
    filterKey: 'payroll_transaction_status',
  },
  {
    title: 'out_of_payroll_types',
    component: OutOfPayrollTypes,
    filterKey: 'payroll_transaction_type_ids',
  },
  {
    title: 'asset_status',
    component: AssetsStatus,
    filterKey: 'asset_status',
  },
  {
    title: 'asset_types',
    component: AssetTypes,
    filterKey: 'asset_types',
  },
  {
    title: 'request_statuses',
    component: RequestStatuses,
    filterKey: 'request_statuses',
  },
  {
    title: 'ats_job_opening_statuses',
    component: ATSJobOpenStatuses,
    filterKey: 'ats_job_opening_statuses',
  },
  {
    title: 'candidate_statuses',
    component: CandidateStatuses,
    filterKey: 'candidate_statuses',
  },
  {
    title: 'pending_on',
    component: RequestsPendingOn,
    filterKey: 'pending_on',
  },
  {
    title: 'request_type',
    component: RequestTypes,
    filterKey: 'request_type',
  },
  {
    title: 'tasks_request_type',
    component: RequestTypes,
    filterKey: 'category',
  },
  {
    title: 'commercial_registration_ids',
    component: CommercialRegistrations,
    filterKey: 'commercial_registration_ids',
  },
  {
    title: 'payment_method',
    component: PaymentProcessingMethods,
    filterKey: 'payment_methods',
  },
  {
    title: 'gosi_linked_payment_processing',
    component: GosiLinkedPaymentProcessing,
    filterKey: 'is_gosi_linked',
  },
  {
    title: 'external_nationalities',
    component: ExternalNationalities,
    filterKey: 'external_nationalities',
  },
  {
    title: 'id_type',
    component: IdTypes,
    filterKey: 'id_type',
  },
  {
    title: 'insurance_policy_class',
    component: InsuranceClasses,
    filterKey: 'insurance_policy_class',
  },
  {
    title: 'insurance_status',
    component: InsuranceStatus,
    filterKey: 'insurance_status',
  },
  {
    title: 'is_member_linked',
    component: MemberLinked,
    filterKey: 'is_member_linked',
  },
  {
    title: 'device_status',
    component: DeviceStatus,
    filterKey: 'device_status',
  },
  {
    title: 'endorsement_request_type',
    component: EndorsementRequestType,
    filterKey: 'endorsement_request_type',
  },
  {
    title: 'endorsement_member_type',
    component: EndorsementMemberType,
    filterKey: 'endorsement_member_type',
  },
  {
    title: 'audit_record_actions',
    component: EmpAuditLogActions,
    filterKey: 'action_type',
  },
  {
    title: 'date_picker_duration',
    component: Duration,
    filterKey: 'duration',
  },
  {
    title: 'invitations_statuses',
    component: EmployeeInvitationsStatus,
    filterKey: 'invitations_statuses',
  },
]

export const initialValues = {
  filters: {},
  mol_registration_ids: [],
  payrun_types: [],
  payrun_status: [],
  filter_payrun_status: [],
  filter_attendance_status: [],
  payroll_transaction_status: [],
  is_data_correct: [],
  is_gosi_linked: [],
  grade_ids: [],
  department_ids: [],
  area_ids: [],
  record_loc_ids: [],
  location_ids: [],
  reporting_method_ids: [],
  biometric_ids: [],
  shift_ids: [],
  job_title_ids: [],
  record_types: [],
  loan_type_ids: [],
  shift_types: [],
  shift_type: [],
  leave_type_ids: [],
  employment_type_ids: [],
  leave_status_ids: [],
  business_unit_ids: [],
  request_status_ids: [],
  request_type_ids: [],
  requests_approvers_list_ids: [],
  outsourcing_company_ids: [],
  statuses: [1],
  payment_methods: [],
  task_statuses: [],
  nationalities: [],
  additional_columns: {},
  additional_info: [],
  document_type: [],
  expiry_status: [],
  extra_cols: [],
  categories: [],
  payroll_transaction_type_ids: [],
  status_employee: [],
  department_id: [],
  area_id: [],
  location_id: [],
  employment_type_id: [],
  business_unit_id: [],
  job_title_id: [],
  grade_id: [],
  gosi_subscriptions: [],
  nationality: [],
  payrunTypes: [],
  status: [1],
  asset_status: [],
  asset_types: [],
  request_statuses: [],
  ats_job_opening_statuses: [],
  candidate_statuses: [],
  country: [],
  job_openings: [],
  pending_on: [],
  request_type: [],
  category: [],
  commercial_registration_ids: [],
  organization_task_id: [],
  external_nationalities: [],
  id_type: [],
  insurance_policy_class: [],
  insurance_status: [],
  is_member_linked: [],
  device_status: [],
  endorsement_request_type: [],
  endorsement_member_type: [],
  action_type: [],
  duration: {},
  invitations_statuses: [],
}

export const newState = {
  mol_registration_ids: [],
  payrun_types: [],
  payrun_status: [],
  filter_payrun_status: [],
  filter_attendance_status: [],
  payroll_transaction_status: [],
  grade_ids: [],
  department_ids: [],
  area_ids: [],
  record_loc_ids: [],
  reporting_method_ids: [],
  shift_ids: [],
  job_title_ids: [],
  record_types: [],
  shift_types: [],
  shift_type: [],
  leave_type_ids: [],
  employment_type_ids: [],
  leave_status_ids: [],
  business_unit_ids: [],
  request_status_ids: [],
  request_type_ids: [],
  requests_approvers_list_ids: [],
  statuses: [],
  status_employee: [],
  payment_methods: [],
  task_statuses: [],
  categories: [],
  country: [],
  nationalities: [],
  document_type: [],
  expiry_status: [],
  loan_type_ids: [],
  location_ids: [],
  record_location_ids: [],
  biometric_ids: [],
  extra_cols: [],
  payroll_transaction_type_ids: [],
  department_id: [],
  area_id: [],
  location_id: [],
  employment_type_id: [],
  business_unit_id: [],
  job_title_id: [],
  grade_id: [],
  gosi_subscriptions: [],
  status: [],
  nationality: [],
  is_gosi_linked: [],
  is_data_correct: [],
  payment_details: [],
  asset_status: [],
  asset_types: [],
  request_statuses: [],
  ats_job_opening_statuses: [],
  candidate_statuses: [],
  job_openings: [],
  pending_on: [],
  request_type: [],
  category: [],
  commercial_registration_ids: [],
  organization_task_id: [],
  external_nationalities: [],
  id_type: [],
  insurance_policy_class: [],
  insurance_status: [],
  is_member_linked: [],
  device_status: [],
  endorsement_request_type: [],
  endorsement_member_type: [],
  action_type: [],
  duration: {},
  invitations_statuses: [],
}

export const filterPairKeys = {
  business_units: 'business_unit_ids',
  departments: 'department_ids',
  document_types: 'document_type',
  employment_types: 'employment_type_ids',
  expiry_status: 'expiry_status',
  gosi_linked: 'is_gosi_linked',
  member_linked: 'is_member_linked',
  grades: 'grade_ids',
  job_titles: 'job_title_ids',
  leave_statuses: 'leave_status_ids',
  leave_types: 'leave_type_ids',
  loan_types: 'loan_type_ids',
  locations: 'location_ids',
  mol_registrations: 'mol_registration_ids',
  payrun_types: 'payrun_types',
  payroll_transaction_status: 'payroll_transaction_status',
  payrun_status: 'payrun_status',
  filter_payrun_status: 'filter_payrun_status',
  filter_attendance_status: 'filter_attendance_status',
  nationalities: 'nationalities',
  out_of_payroll_types: 'payroll_transaction_type_ids',
  outsourcing_company: 'outsourcing_company_ids',
  payment_methods: 'payment_methods',
  record_types: 'record_types',
  reporting_method: 'reporting_method_ids',
  request_statuses: 'request_statuses',
  ats_job_opening_statuses: 'ats_job_opening_statuses',
  candidate_statuses: 'candidate_statuses',
  country: 'country',
  job_openings: 'job_openings',
  request_type: 'request_type_ids',
  category: 'category',
  organization_task_id: 'organization_task_id',
  requests_approvers_list: 'requests_approvers_list_ids',
  shift_types: 'shift_types',
  shift_type: 'shift_type',
  shifts: 'shift_ids',
  status_employee: 'status_employee',
  statuses: 'statuses',
  task_statuses: 'task_statuses',
  tasks_categories: 'categories',
  uncorrect_data: 'is_data_correct',
  biometrics: 'biometric_ids',
  business_unit_id: 'business_unit_id',
  department_id: 'department_id',
  employment_type_id: 'employment_type_id',
  grade_id: 'grade_id',
  location_id: 'location_id',
  job_title_id: 'job_title_id',
  gosi_subscriptions: 'gosi_subscriptions',
  status: 'status',
  record_location: 'record_location_ids',
  nationality: 'nationality',
  punch_in: 'punch_in',
  punch_out: 'punch_out',
  pending_on: 'pending_on',
  asset_status: 'asset_status',
  asset_types: 'asset_types',
  commercial_registration_ids: 'commercial_registration_ids',
  external_nationalities: 'external_nationalities',
  id_type: 'id_type',
  insurance_policy_class: 'insurance_policy_class',
  insurance_status: 'insurance_status',
  device_status: 'device_status',
  endorsement_request_type: 'endorsement_request_type',
  endorsement_member_type: 'endorsement_member_type',
  action_type: 'action_type',
  duration: 'duration',
  invitations_statuses: 'invitations_statuses',
}

export const groupingFilter = {
  filters: ['area_ids', 'area_id', 'record_loc_ids', 'reporting_method_ids'],
  area_ids: {
    key_name: 'area_id',
    list: 'locations',
    insert_ids_keys: 'area_ids',
  },
  area_id: {
    key_name: 'area_id',
    list: 'locations',
    insert_ids_keys: 'location_id',
  },
  record_loc_ids: {
    key_name: 'area_id',
    list: 'locations',
    insert_ids_keys: 'record_location_ids',
  },
  reporting_method_ids: {
    key_name: 'reporting_method_id',
    list: 'biometrics',
    insert_ids_keys: 'biometric_ids',
  },
}

export function getSelectedFilters(state, filters) {
  const selected = {}

  filters.map((key) => {
    selected[filterPairKeys[key]] = state[filterPairKeys[key]]
    return key
  })

  return selected
}

export function handleSelectGroupingFilter(data) {
  const { list, name, id } = data
  const ids = list.filter((f) => f[name] === id).map((loca) => loca.id)
  return ids
}

export function handleRemoveSelectedGroupingFilter(data) {
  const { list, id, selectedIds, name } = data

  const getSelectedList = list
    .filter((f) => f[name] === id)
    .filter((li) => selectedIds.includes(li.id))
    .map((li) => li.id)

  return selectedIds.filter((sid) => !getSelectedList.includes(sid))
}

export const transformFilters = (filters, transformfilterKeys) => {
  const transformFilter = {}
  Object.entries(transformfilterKeys).forEach(([key, value]) => {
    if (filters?.filter?.[key]?.length) transformFilter[value] = filters?.filter?.[key]
  })
  return { ...filters, filter: transformFilter }
}

export const returnBadgeList = (list) => {
  return list.map((li) => ({ ...li, label: i18n.t(li.name), testId: li.name?.toLowerCase() }))
}

export const getPublicFilterKeys = (filters = []) => {
  let keys = {}
  let lookups = []
  const getKeys = (key) => {
    switch (key) {
      case 'location_area':
        return {
          area: true,
        }

      case 'locations':
      case 'location_id':
      case 'areas':
      case 'record_location':
        return {
          location: true,
          area: true,
        }

      case 'departments':
      case 'department_id':
        return {
          department: {
            hierarchical: true,
          },
        }

      case 'mol_registrations':
      case 'gosi_subscriptions':
        return {
          mol_registration: true,
        }
      case 'country':
        return {
          country: true,
        }

      case 'employment_type_id':
      case 'employment_types':
        return {
          employment_type: true,
        }

      case 'nationality':
      case 'nationalities':
        return {
          nationality: {
            employee_list: true,
          },
        }

      case 'job_titles':
      case 'job_title_id':
        return {
          job_title: true,
        }

      case 'business_units':
      case 'business_unit_id':
        return {
          business_unit: true,
        }

      case 'outsourcing_company':
        return {
          outsourcing_companies: true,
        }

      case 'shifts':
        return {
          shift: true,
        }

      case 'grades':
      case 'grade_id':
        return {
          grade: true,
        }

      case 'loan_types':
        return {
          loan_type: true,
        }

      case 'document_types':
        return {
          document_type: true,
        }

      case 'out_of_payroll_types':
        return {
          payroll_transaction_type: {
            show_vs_fs: false,
            category: 'PayTypePage',
          },
        }

      case 'leave_types':
        return {
          leave_type: true,
        }

      case 'asset_types':
        return {
          asset_type: true,
        }
      case 'request_type':
        return {
          request_type: true,
          archived_request_type: true,
        }
      case 'task_type':
        return {
          organization_task: true,
        }
      case 'commercial_registration_ids':
        return {
          commercial_registration: true,
        }

      case 'external_nationalities':
        lookups = uniq([...lookups, 'nationality'])
        return {
          lookups,
        }
      case 'id_type':
        lookups = uniq([...lookups, 'id_type'])
        return {
          lookups,
        }
      case 'insurance_policy_class':
        lookups = uniq([...lookups, 'insurance_policy_class'])
        return {
          lookups,
        }
      case 'endorsement_request_type':
        lookups = uniq([...lookups, 'endorsement_type'])
        return {
          lookups,
        }

      default:
        return null
    }
  }

  filters.forEach((filter) => {
    if (getKeys(filter)) {
      keys = {
        ...keys,
        ...getKeys(filter),
      }
    }
  })

  return keys
}

export const canShowClearFilter = (filter, filterKey, optionFilterKey, subOptionFilterKey) => {
  if (['statuses'].includes(filterKey)) {
    return !isEmpty(filter.statuses || [])
  }
  if (['status_employee'].includes(filterKey)) {
    return !isEmpty(filter.status_employee || [])
  }
  const emptyFilter = isEmpty(filter[filterKey] || [])
  const emptyOptionsFilter = isEmpty(filter[optionFilterKey] || [])
  const emptySubOptionsFilter = isEmpty(filter[subOptionFilterKey] || [])
  return !emptyFilter || !emptyOptionsFilter || !emptySubOptionsFilter
}

export const getTranslatedList = (list, key) => {
  return list.map((li) => ({ ...li, [`${[key]}_i18n`]: i18n.t(li?.[key]), testId: li?.[key] }))
}

export const getUniqueList = (list1, list2) => {
  const li1 = list1.map((l) => l.id)
  const li2 = list2.filter((l) => !li1.includes(l.id))
  return [...li2, ...list1]
}
